module.exports = __webpack_public_path__ + "img/335.0cbb7685.png";